"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
exports.default = (function (virtual) { return function (frame) {
    var subDevices = virtual.device.subDevices;
    var subDevTid = virtual.options.subDevTid;
    // 看是否把子设备添加到网关下面
    if (subDevTid) {
        var sub = utils_1.find(subDevices, function (_a) {
            var devTid = _a.devTid;
            return devTid === subDevTid;
        });
        if (sub) {
            virtual.send('reportSubDevInfo');
        }
        else {
            virtual.send('addSubDev');
        }
    }
    else {
        virtual.send('getTimerList');
    }
    // 独立设备完成登录
    virtual['[[RESOLVE]]']();
    setTimeout(function () {
        virtual.send('getTimerList');
    }, 1800000);
}; });



// WEBPACK FOOTER //
// ./src/actions/receive/actions/reportDevInfoResp.ts